import { generateKeys } from '../utils';
export const departments = generateKeys({
    technology: {
        value: 'technology',
        label: 'Technology',
    },
    marketing: {
        value: 'marketing',
        label: 'Marketing',
    },
    accountOpening: {
        value: 'accountOpening',
        label: 'Account Opening',
    },
    partnerOperations: {
        value: 'partnerOperations',
        label: 'Partner Operations',
    },
    businessDevelopmentManagers: {
        value: 'businessDevelopmentManagers',
        label: 'Business Development Managers',
    },
    businessIntelligence: {
        value: 'businessIntelligence',
        label: 'Business Intelligence',
    },
    middleEastAndNorthAfrica: {
        value: 'middleEastAndNorthAfrica',
        label: 'Middle East And North Africa',
    },
    customerSupport: {
        value: 'customerSupport',
        label: 'Customer Support',
    },
    sales: {
        value: 'sales',
        label: 'Sales',
    },
    funding: {
        value: 'funding',
        label: 'Funding',
    },
    dealing: {
        value: 'dealing',
        label: 'Dealing',
    },
    payment: {
        value: 'payment',
        label: 'Payment',
    },
    compliance: {
        value: 'compliance',
        label: 'Compliance',
    },
    accounting: {
        value: 'accounting',
        label: 'Accounting',
    },
    reconciliation: {
        value: 'reconciliation',
        label: 'Reconciliation',
    },
    system: {
        value: 'system',
        label: 'System',
        hidden: true,
    },
    unassigned: {
        value: 'unassigned',
        label: 'Unassinged',
    },
});
